/**
 * Normalizes list `meta` from snake_case or camelCase into one shape for UI.
 *
 * @param {Record<string, unknown> | null | undefined} meta
 * @param {number} fallbackPage
 * @param {number} fallbackPageSize
 */
export const normalizePagedMeta = (meta, fallbackPage, fallbackPageSize) => {
  const m = meta && typeof meta === 'object' ? meta : {};
  const total_items = Number(m.total_items ?? m.totalItems ?? 0) || 0;
  const total_pages = Math.max(1, Number(m.total_pages ?? m.totalPages ?? 1) || 1);
  const current_page = Number(m.current_page ?? m.currentPage ?? fallbackPage) || fallbackPage;
  const per_page = Number(m.per_page ?? m.perPage ?? fallbackPageSize) || fallbackPageSize;
  return {
    total_items,
    total_pages,
    current_page,
    per_page,
    has_next: Boolean(m.has_next ?? m.hasNext),
    has_previous: Boolean(m.has_previous ?? m.hasPrevious),
  };
};
